import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './layout/AppLayout';
import { Overview } from './pages/Overview';
import { MapPage } from './pages/MapPage';
import { Reports } from './pages/Reports';
import { CustomerDetail } from './pages/CustomerDetail';
import { ExtinguisherEdit } from './pages/ExtinguisherEdit';
import { HoseEdit } from './pages/HoseEdit';
import { HoseReport } from './pages/HoseReport';
import { Invoice } from './pages/Invoice';
import { HoseOptions } from './pages/admin/HoseOptions';
import { Manufacturers } from './pages/admin/Manufacturers';
import { DeviceTypes } from './pages/admin/DeviceTypes';
import { SpareParts } from './pages/admin/SpareParts';
import { ServicePrices } from './pages/admin/ServicePrices';
import { Workers } from './pages/admin/Workers';
import { SettingsPage } from './pages/admin/Settings';
import { ImportExport } from './pages/ImportExport';
import { CalendarPage } from './pages/Calendar';
import { Login } from './pages/Login';
import { Toasts } from './components/Toasts';
import { Tour } from './components/Tour';
import { TourBoot } from './components/TourBoot';
import { AuthGate } from './components/AuthGate';
import { RequireRole } from './components/RequireRole';
import { Tenants as SuperTenants } from './pages/superadmin/Tenants';
import { TenantNew } from './pages/superadmin/TenantNew';
import { TenantDetail } from './pages/superadmin/TenantDetail';
import { PlatformAudit } from './pages/superadmin/PlatformAudit';

export function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <AuthGate>
              <AppLayout />
            </AuthGate>
          }
        >
          <Route index element={<Navigate to="/overview" replace />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/customer/:id" element={<CustomerDetail />} />
          <Route path="/customer/:id/:tab" element={<CustomerDetail />} />
          <Route
            path="/customer/:id/extinguisher/:extId"
            element={<ExtinguisherEdit />}
          />
          <Route path="/customer/:id/hose/:hoseId" element={<HoseEdit />} />
          <Route path="/customer/:id/hose-report" element={<HoseReport />} />
          <Route path="/customer/:id/invoice" element={<Invoice />} />
          <Route
            path="/admin/manufacturers"
            element={
              <RequireRole roles={['org_admin']}>
                <Manufacturers />
              </RequireRole>
            }
          />
          <Route
            path="/admin/device-types"
            element={
              <RequireRole roles={['org_admin']}>
                <DeviceTypes />
              </RequireRole>
            }
          />
          <Route
            path="/admin/spare-parts"
            element={
              <RequireRole roles={['org_admin']}>
                <SpareParts />
              </RequireRole>
            }
          />
          <Route
            path="/admin/service-prices"
            element={
              <RequireRole roles={['org_admin']}>
                <ServicePrices />
              </RequireRole>
            }
          />
          <Route
            path="/admin/workers"
            element={
              <RequireRole roles={['org_admin']}>
                <Workers />
              </RequireRole>
            }
          />
          <Route
            path="/admin/hose-options"
            element={
              <RequireRole roles={['org_admin']}>
                <HoseOptions />
              </RequireRole>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <RequireRole roles={['org_admin']}>
                <SettingsPage />
              </RequireRole>
            }
          />
          <Route
            path="/import-export"
            element={
              <RequireRole roles={['org_admin']}>
                <ImportExport />
              </RequireRole>
            }
          />
          <Route
            path="/superadmin"
            element={<Navigate to="/superadmin/tenants" replace />}
          />
          <Route
            path="/superadmin/tenants"
            element={
              <RequireRole roles={['super_admin']}>
                <SuperTenants />
              </RequireRole>
            }
          />
          <Route
            path="/superadmin/tenants/new"
            element={
              <RequireRole roles={['super_admin']}>
                <TenantNew />
              </RequireRole>
            }
          />
          <Route
            path="/superadmin/tenants/:id"
            element={
              <RequireRole roles={['super_admin']}>
                <TenantDetail />
              </RequireRole>
            }
          />
          <Route
            path="/superadmin/audit"
            element={
              <RequireRole roles={['super_admin']}>
                <PlatformAudit />
              </RequireRole>
            }
          />
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Route>
      </Routes>
      <Toasts />
      <Tour />
      <TourBoot />
    </HashRouter>
  );
}
